module.exports = ".example-icon {\n  padding: 0 14px;\n  cursor: pointer; }\n\n.example-spacer {\n  flex: 1 1 auto; }\n"